let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h9vcm")).then(() => parcelRequire('5DuQv'));